<div class="spinner-container">
    <div class="card">
        <p-progressSpinner 
            [style]="{width: '150px', height: '150px'}" 
            ariaLabel="authenticating" 
            styleClass="w-4rem h-4rem" 
            strokeWidth="8" 
            fill="var(--surface-ground)" 
            animationDuration=".5s"
        ></p-progressSpinner>
    </div>
    <span>Authenticating ...</span>
</div>